import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Native range slider (`<input type="range">`, Bootstrap `.form-control-range`)
 * used by editor toolbars (floor-plan canvas opacity controls). Standalone:
 * the parent drives `[value]` and reads the raw events (`$event.target.value`).
 */
@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss'],
})
export class RangeSliderComponent {
  @Input() value: number | string = 0;
  @Input() min: number | string = 0;
  @Input() max: number | string = 1;
  @Input() step: number | string = 0.1;
  /** Extra class(es) on the input. */
  @Input() cssClass = '';

  /** Raw input event (live while dragging). */
  @Output() inputEvent = new EventEmitter<Event>();
  /** Raw change event (drag committed). */
  @Output() changeEvent = new EventEmitter<Event>();
}
